import React, {FC, PropsWithChildren} from 'react';

import {cn} from '@bem-react/classname';
import {ArrowToggle, Button, Card, Text} from '@gravity-ui/uikit';
import {useToggle} from 'react-use';

import {CollapsableCardProps} from './CollapsableCard.types';

import './CollapsableCard.scss';

const cnCollapsableCard = cn('CollapsableCard');

const CollapsableCard: FC<PropsWithChildren<CollapsableCardProps>> = ({
    title,
    children,
    openedByDefault = true,
    uniqKey,
}) => {
    const [opened, toggle] = useToggle(openedByDefault);

    return (
        <section>
            <Card className={cnCollapsableCard()}>
                <h2 className={cnCollapsableCard('Header')}>
                    <button
                        className={cnCollapsableCard('HeaderButton', {opened})}
                        onClick={toggle}
                        type="button"
                        aria-expanded={opened}
                        aria-controls={`${uniqKey}-area`}
                        id={`${uniqKey}-control`}
                    >
                        <Text variant="subheader-3" as="div" className={cnCollapsableCard('Title')}>
                            {title}
                        </Text>
                        <Button
                            view="flat"
                            size="m"
                            className={cnCollapsableCard('Toggle')}
                            tabIndex={-1}
                            extraProps={{'aria-hidden': true}}
                        >
                            <Button.Icon>
                                <ArrowToggle direction={opened ? 'top' : 'bottom'} size={23} />
                            </Button.Icon>
                        </Button>
                    </button>
                </h2>
                {opened && (
                    <div
                        className={cnCollapsableCard('Body')}
                        id={`${uniqKey}-area`}
                        role="region"
                        aria-labelledby={`${uniqKey}-control`}
                    >
                        {children}
                    </div>
                )}
            </Card>
        </section>
    );
};
export default CollapsableCard;
